import React, { useState } from 'react';
import { Container, Typography, Box, TextField, Button, Grid, Paper, Alert, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';

const FormularioGuardarTurnos = () => {
  const [numTurnos, setNumTurnos] = useState(1);
  const [turnos, setTurnos] = useState([{ inicio: '', fin: '' }]);
  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFin, setFechaFin] = useState('');
  const [mensaje, setMensaje] = useState(null);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [asignacionesExistentes, setAsignacionesExistentes] = useState(0);

  const handleNumTurnosChange = (e) => {
    const n = parseInt(e.target.value, 10);
    setNumTurnos(n);
    setTurnos(Array(n).fill().map((_, i) => turnos[i] || { inicio: '', fin: '' }));
  };

  const handleTurnoChange = (i, field, value) => {
    const nuevosTurnos = [...turnos];
    nuevosTurnos[i][field] = value;
    setTurnos(nuevosTurnos);
  };

  const verificarAsignaciones = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/verificar-asignaciones?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`);
      const data = await response.json();
      return data.cantidad || 0;
    } catch (error) {
      console.error('Error verificando asignaciones:', error);
      return 0;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMensaje(null);
    
    // Verificar si hay asignaciones existentes
    const cantidad = await verificarAsignaciones();
    
    if (cantidad > 0) {
      setAsignacionesExistentes(cantidad);
      setOpenConfirm(true);
    } else {
      guardarParametros();
    }
  };

  const guardarParametros = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/parametros-turnos`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ turnos, fechaInicio, fechaFin, eliminarAsignaciones: true })
      });
      const data = await response.json();
      if (response.ok) {
        setMensaje({ tipo: 'success', texto: data.mensaje || 'Parámetros de turnos guardados correctamente.' });
        setOpenConfirm(false);
      } else {
        setMensaje({ tipo: 'error', texto: data.error || 'Error guardando parámetros de turnos.' });
        setOpenConfirm(false);
      }
    } catch (error) {
      setMensaje({ tipo: 'error', texto: 'Error de conexión al guardar.' });
      setOpenConfirm(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Paper elevation={3} sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>
          Ingreso parametros Turnos
        </Typography>
        <form onSubmit={handleSubmit}>
          <Box sx={{ mb: 2 }}>
            <TextField
              label="Fecha de inicio del periodo"
              type="date"
              value={fechaInicio}
              onChange={e => setFechaInicio(e.target.value)}
              InputLabelProps={{ shrink: true }}
              fullWidth
              required
              sx={{ mb: 2 }}
            />
            <TextField
              label="Fecha de fin del periodo"
              type="date"
              value={fechaFin}
              onChange={e => setFechaFin(e.target.value)}
              InputLabelProps={{ shrink: true }}
              fullWidth
              required
              sx={{ mb: 2 }}
            />
            <TextField
              select
              label="Número de turnos"
              value={numTurnos}
              onChange={handleNumTurnosChange}
              SelectProps={{ native: true }}
              fullWidth
              required
              sx={{ mb: 2 }}
            >
              <option value={1}>1</option>
              <option value={2}>2</option>
              <option value={3}>3</option>
            </TextField>
          </Box>
          <Grid container spacing={2}>
            {turnos.map((turno, i) => (
              <React.Fragment key={i}>
                <Grid item xs={6}>
                  <TextField
                    label={`Hora inicio turno ${i + 1}`}
                    type="time"
                    value={turno.inicio}
                    onChange={e => handleTurnoChange(i, 'inicio', e.target.value)}
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    label={`Hora fin turno ${i + 1}`}
                    type="time"
                    value={turno.fin}
                    onChange={e => handleTurnoChange(i, 'fin', e.target.value)}
                    fullWidth
                    required
                  />
                </Grid>
              </React.Fragment>
            ))}
          </Grid>
          <Box sx={{ mt: 4, textAlign: 'center' }}>
            <Button type="submit" variant="contained" color="primary">
              Guardar Parámetros de Turnos
            </Button>
          </Box>
        </form>
        {mensaje && (
          <Alert severity={mensaje.tipo} sx={{ mt: 3 }}>
            {mensaje.texto}
          </Alert>
        )}
      </Paper>

      <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)}>
        <DialogTitle>Confirmar cambio de parámetros</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Se encontraron {asignacionesExistentes} asignaciones de operarios en el rango de fechas seleccionado.
            Al cambiar los parámetros de turnos, estas asignaciones serán eliminadas.
            ¿Deseas continuar?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirm(false)} color="primary">
            Cancelar
          </Button>
          <Button onClick={guardarParametros} color="error" variant="contained">
            Confirmar y Eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default FormularioGuardarTurnos;